import { QueovalBase } from './global';

export class CompressedModel extends QueovalBase {
  public ObjectCompressed: string;
  public ApiPath: string;
}
